(function () {
  document.querySelectorAll('[data-holy-1010-countdown]').forEach(function (counter) {
    if (counter.dataset.ready) return;
    counter.dataset.ready = 'true';
    const header = document.querySelector('[data-hc-bar]');
    const config = header?.dataset || counter.dataset;
    const start = Date.parse(config.startDate + 'T' + (config.startTime || '00:00') + ':00-03:00');
    const end = Date.parse(config.endDate + 'T' + (config.endTime || '00:00') + ':00-03:00');
    let timer;
    function tick() {
      if (!counter.isConnected) { clearInterval(timer); return; }
      const now = Date.now();
      const label = counter.querySelector('[data-holy-timer-label]');
      if (!Number.isFinite(start) || !Number.isFinite(end)) { counter.hidden = true; clearInterval(timer); return; }
      const upcoming = now < start;
      const expired = now >= end;
      label.textContent = expired ? '10.10 encerrada' : upcoming ? 'O 10.10 começa em' : (counter.dataset.activeLabel || 'O 10.10 termina em');
      counter.querySelector('[data-holy-timer-units]').hidden = expired;
      if (expired) { clearInterval(timer); return; }
      const remaining = Math.max(0, Math.floor(((upcoming ? start : end) - now) / 1000));
      const parts = {days:Math.floor(remaining/86400),hours:Math.floor(remaining%86400/3600),minutes:Math.floor(remaining%3600/60),seconds:remaining%60};
      Object.entries(parts).forEach(([key, value]) => {
        counter.querySelector('[data-holy-timer-' + key + ']').textContent = String(value).padStart(2,'0');
      });
    }
    tick();
    if (Date.now() < end) timer = setInterval(tick, 1000);
  });
})();
